import { FeedMode } from '@/types/models/Term.model'
import { Department } from '@/domain/department/department'
import { PrimaryFocus } from '@/domain/primaryFocus/constant'

interface GetPrimaryFocusLabelByDepartmentAndFeedModeParams {
  primaryFocus: string
  termFeedMode: FeedMode
  department: Department
}

/**
 * Returns the appropriate primary focus display label based on feed mode and department rules.
 * For example, when in STRICT mode and MentalHealth department, "Substance Use and Mental Health"
 * should be displayed as "Mental Health".
 */
export function getPrimaryFocusLabelByDepartmentAndFeedMode({
  primaryFocus,
  termFeedMode,
  department
}: GetPrimaryFocusLabelByDepartmentAndFeedModeParams): string {
  if (
    termFeedMode === FeedMode.PRIMARY_FOCUS_STRICT &&
    department === Department.MentalHealth &&
    primaryFocus === PrimaryFocus.SUBSTANCE_USE_AND_MENTAL_HEALTH
  ) {
    return PrimaryFocus.MENTAL_HEALTH
  }

  return primaryFocus
}
